import { DatePipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ShowArchiveService } from '../../services/show-archive.service';

@Component({
  selector: 'app-show-detail',
  standalone: true,
  imports: [RouterLink, DatePipe],
  template: `
    @if (event()) {
      <section class="section page-heading premium-heading detail-hero">
        <a routerLink="/spielshows" class="back-link">← Zurück zu Shows</a>
        <p class="eyebrow">{{ event()!.format }} · {{ event()!.status }}</p>
        <h1>{{ event()!.title }}</h1>
        <p class="lead">{{ event()!.date | date:'dd.MM.yyyy' }} · {{ event()!.questionCount }} Fragen · Gewinner: {{ event()!.winner }}</p>
      </section>

      <section class="section grid three">
        <article class="card big-stat accent-card"><span>{{ event()!.questionCount }}</span><p>Fragen / Challenges</p></article>
        <article class="card big-stat accent-card"><span>{{ event()!.participants.length }}</span><p>Beteiligte</p></article>
        <article class="card big-stat accent-card"><span>{{ event()!.questionResults.length }}</span><p>freigegebene Ergebnisse</p></article>
      </section>

      <section class="section grid two">
        <article class="card accent-card">
          <p class="tag">Teilnehmer</p>
          <h2>Wer war dabei?</h2>
          <div class="participant-list">
            @for (participant of event()!.participants; track participant.name) {
              <div class="participant-row">
                <span class="place">{{ participant.finalPlace === 0 ? 'Host' : '#' + participant.finalPlace }}</span>
                <div>
                  <strong>{{ participant.name }}</strong>
                  <small>{{ participant.role }} · {{ participant.correctAnswers }} richtige / nächste Antworten · {{ participant.chips }} Chips</small>
                </div>
              </div>
            }
          </div>
        </article>

        <article class="card accent-card">
          <p class="tag">Hinweis</p>
          <h2>Keine öffentliche Fragen-Datenbank</h2>
          <p>Die globale Fragenliste wird nicht öffentlich ausgespielt. Diese Detailseite ist als Show-Rückblick gedacht: Nur Fragen und Ergebnisse, die zu dieser konkreten Show freigegeben wurden, werden hier angezeigt.</p>
        </article>
      </section>

      <section class="section">
        <h2 class="section-title">Freigegebene Fragen & Ergebnisse</h2>
        @if (event()!.questionResults.length > 0) {
          <div class="result-grid">
            @for (question of event()!.questionResults; track question.round) {
              <article class="card result-card accent-card">
                <p class="tag">Runde {{ question.round }} · {{ question.category }}</p>
                <h3>{{ question.question }}</h3>
                <div class="result-facts">
                  <span><strong>Lösung</strong>{{ question.answer }}</span>
                  <span><strong>Nächste Schätzung</strong>{{ question.closestPlayer }}</span>
                  <span><strong>Pot gewonnen</strong>{{ question.winner }} · {{ question.pot }} Chips</span>
                </div>
              </article>
            }
          </div>
        } @else {
          <article class="card accent-card empty-state">
            <h3>Noch keine Fragen freigegeben</h3>
            <p>Bei geplanten Shows erscheinen hier später erst nach der Show die freigegebenen Fragen, Antworten, Teilnehmer und Gewinner.</p>
          </article>
        }
      </section>
    } @else {
      <section class="section page-heading">
        <h1>Show nicht gefunden</h1>
        <p class="lead">Diese Show existiert im Entwurf nicht.</p>
        <a routerLink="/spielshows" class="button primary">Zurück zum Archiv</a>
      </section>
    }
  `
})
export class ShowDetailComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly archive = inject(ShowArchiveService);
  readonly event = computed(() => this.archive.getById(this.route.snapshot.paramMap.get('id') ?? ''));
}
